import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';

interface ICreateBackOfficeAccountDialogProps {
    dialogName: string;
    userName: string;
    createAccount?: (userName: string, password: string) => void;
    projects: ProspectDetails[];
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
}

const CreateBackOfficeAccountDialog = (props: ICreateBackOfficeAccountDialogProps) => {
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const OKClicked = () => {
        let data = getValues();
        props.createAccount(data.userName, data.password);
        console.log('OK Clicked', data);
        props.hideDialog();
    };

    return (
        <Dialog title="Create User Name" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFInputBox
                        label="User Name"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        defaultVal={props?.userName}
                        name={`userName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Password"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        name={`password`}
                        type="password"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default CreateBackOfficeAccountDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/CreateBackOfficeAccountDialog.tsx